// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollableRow_container__2rUyC"};